import { useAppDispatch, useAppSelector } from "app/hooks"
import { useFailed, useSuccess } from "features/notification/hooks"
import { MealType } from "model/food/types"
import { IUpdateMealPayload } from "model/food/types/mealPayload.types"
import getMealPayloadFromMeal from "model/food/utils/getPayloads/getMealPayloadFromMeal"
import { updateFavoriteMeal } from "../favoriteMealsSlice"

export const useUpdateFavoriteMeal = (callback?: () => void) => {
  const updateFavoriteMealLoading = useAppSelector(
    (state) => state.favoriteMeals.updateFavoriteMealLoading,
  )
  const updateFavoriteMealSuccess = useAppSelector(
    (state) => state.favoriteMeals.updateFavoriteMealSuccess,
  )
  const updateFavoriteMealFailed = useAppSelector(
    (state) => state.favoriteMeals.updateFavoriteMealFailed,
  )

  const dispatch = useAppDispatch()

  const handleUpdateFavoriteMeal = (meal: MealType) => {
    const mealPayload = getMealPayloadFromMeal(meal)
    mealPayload.isManualNutrition = meal.isManualNutrition ?? false

    const payload: IUpdateMealPayload = {
      id: meal.id,
      payload: mealPayload,
    }

    dispatch(updateFavoriteMeal(payload))
  }

  useFailed(updateFavoriteMealFailed)
  useSuccess(updateFavoriteMealSuccess, { message: "" }, callback)

  return {
    updateFavoriteMealLoading,
    handleUpdateFavoriteMeal,
  }
}
